import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#B20FC0",
      "fill-rule": "evenodd",
      d: "M7.47 15.03a.75.75 0 0 1 0-1.06L11.44 10 7.47 6.03a.75.75 0 0 1 1.06-1.06l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "link-arrow"}) } }